<template>
  <div>
    <div class="pc-header">
      <div class="brand-icon" @click="onBrandClick">
        <img src="@assets/imgs/logowhite.png" width="80%" />
      </div>
      <div class="nav">
        <div class="nav-left">
          <div
            :class="['nav-item', { active: curNav1 === '0' }]"
            @click="() => onNavClick(0)"
          >
            <span>{{ $t("index.猎户座") }}</span>
            <!-- <div class="second-nav">
              <div
                :class="['second-nav-item', { active: curNav === '0_0' }]"
                @click.stop="() => onNavClick(0, 0)"
              >
                {{ $t("product.product") }}
              </div>
              <div
                v-if="false"
                :class="['second-nav-item', { active: curNav === '0_1' }]"
                @click.stop="() => onNavClick(0, 1)"
              >
                {{ $t("product.app") }}
              </div>
              
              <div
                :class="['second-nav-item', { active: curNav === '0_3' }]"
                @click.stop="() => onNavClick(0, 3)"
              >
                {{ $t("index.品牌大事件") }}
              </div>
            </div> -->
          </div>
          <div
            :class="['nav-item', { active: curNav1 === '1' }]"
            @click="() => onNavClick(1)"
          >
            <span>{{ $t("index.vr看车") }}</span>
            <!-- <div class="second-nav">
              <div
                :class="['second-nav-item', { active: curNav === '1_1' }]"
                @click.stop="() => onNavClick(1, 1)"
              >
                {{ $t("lifeStyle.摩友圈") }}
              </div>
              <div
                :class="['second-nav-item', { active: curNav === '1_2' }]"
                @click.stop="() => onNavClick(1, 2)"
              >
                {{ $t("lifeStyle.俱乐部") }}
              </div>
            </div> -->
          </div>
          <!-- <div
            :class="['nav-item', { active: curNav1 === '5' }]"
            @click="() => onNavClick(5)"
          >
            <span>{{ $t("index.商城") }}</span>
          </div> -->
          <div :class="['nav-item', { active: curNav1 === '6' }]" v-if="false">
            <span>{{ $t("index.社区") }}</span>
            <div class="second-nav" style="bottom: -40px; height: 50px">
              <div
                :class="['second-nav-item', { active: curNav === '6_1' }]"
                @click.stop="() => onNavClick(6, 1)"
              >
                {{ $t("lifeStyle.摩友圈") }}
              </div>
            </div>
          </div>
          <div :class="['nav-item', { active: curNav1 === '3' }]">
            <span>{{ $t("index.品牌") }}</span>
            <div class="second-nav" style="bottom: -120px; height: 130px">
              <div
                :class="['second-nav-item', { active: curNav === '3_1' }]"
                @click.stop="() => onNavClick(3, 1)"
              >
                {{ $t("index.品牌理念") }}
              </div>
              <div
                :class="['second-nav-item', { active: curNav === '3_2' }]"
                @click.stop="() => onNavClick(3, 2)"
              >
                {{ $t("index.品牌大事件") }}
              </div>
              <div
                :class="['second-nav-item', { active: curNav === '3_3' }]"
                @click.stop="() => onNavClick(3, 3)"
              >
                {{ $t("index.品牌课堂") }}
              </div>
            </div>
          </div>
          <div :class="['nav-item', { active: curNav1 === '7' }]">
            <span>{{ $t("index.关于我们") }}</span>
            <div class="second-nav" style="bottom: -40px; height: 50px">
              <div
                :class="['second-nav-item', { active: curNav === '7_1' }]"
                @click.stop="() => onNavClick(7, 1)"
              >
                {{ $t("lifeStyle.格物电动摩托车") }}
              </div>
              <!-- <div
                :class="['second-nav-item', { active: curNav === '7_2' }]"
                @click.stop="() => onNavClick(7, 2)"
              >
                {{ $t("partner.合作伙伴") }}
              </div> -->
              <!-- <div
                :class="['second-nav-item', { active: curNav === '1_3' }]"
                @click.stop="() => onNavClick(1, 3)"
              >
                {{ $t("lifeStyle.媒体中心") }}
              </div>
              <div
                :class="['second-nav-item', { active: curNav === '1_4' }]"
                @click.stop="() => onNavClick(1, 4)"
              >
                {{ $t("lifeStyle.帮助中心") }}
              </div> -->
            </div>
          </div>
          <div
            v-if="false"
            :class="['nav-item', { active: curNav1 === '2' }]"
            @click="() => onNavClick(2)"
          >
            {{ $t("index.服务与支持") }}
          </div>
        </div>
        <div class="nav-right">
          <div class="nav-item" v-if="!isCN">
            <el-select
              size="middle"
              :value="lang"
              @change="onChangeLang"
              style="width: 100px"
            >
              <el-option
                v-for="item in lang_options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
                <div
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                  "
                >
                  <span style="float: left">{{ item.label }}</span>
                  <img
                    :src="
                      require('@assets/imgs/nationalflag/' + item.img + '.png')
                    "
                    style="width: 20px"
                  />
                </div>
              </el-option>
            </el-select>
          </div>
          <template>
            <div
              v-if="isLogin"
              :class="['user-item', 'nav-item', { active: curNav1 === '4' }]"
              @click="() => onNavClick(4)"
            >
              <i class="el-icon-user"></i>
            </div>
            <div v-if="!isLogin" class="nav-item" @click="onLogin">
              {{ $t("index.登录") }}
            </div>
          </template>
          <div class="nav-item">
            <div class="boxbor" @click="gopartner">
              &nbsp;&nbsp; &nbsp;&nbsp;<span>{{
                $t("index.合作伙伴申请")
              }}</span
              >&nbsp;&nbsp;&nbsp;&nbsp;
            </div>
          </div>
        </div>
      </div>
    </div>
    <FloatBall />
    <!-- <Modal v-model="show" :title="$t('index.立即申请')">
      <PartForm ref="form" @submit="closePopUp" />
    </Modal> -->
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import { goto } from "@utils/goto";
import RouteMap, { activeRoute } from "./RouteMap";
import FloatBall from "../../pages/index/components/FloatBall.vue";
// import Modal from "@components/Modal";
// import PartForm from "./PartForm";

export default {
  // components: { Modal, PartForm },
  components: { FloatBall },
  computed: {
    ...mapState(["lang", "profile"]),
    ...mapGetters(["isLogin"]),
    curNav1() {
      if (/^([^_]*)[_]/.test(this.curNav)) {
        return RegExp.$1;
      }
      return undefined;
    },
    isCN() {
      return this.lang === "zh-CN";
    },
  },
  data() {
    return {
      // show: false,
      curNav: activeRoute,
      nowlang: "",
      currentUrl: "",
      lang_options: [
        { value: "en-US", label: "EN", img: "England" },
        { value: "ru-RU", label: "RU", img: "Russia" },
        { value: "fr-FR", label: "FR", img: "France" },
        { value: "es-ES", label: "ES", img: "Spain" },
        { value: "ja-JP", label: "JP", img: "Japan" },
      ],
    };
  },
  mounted() {
    this.currentUrl = window.location.hostname + "nowlang";
    if (!this.isCN) {
      //每进入一个页面先获取当前存在localStorage的语言字段nowlang
      this.nowlang = localStorage.getItem(this.currentUrl);
      //url参数改变语言存入localStorage
      const langid = window.location.href.split("lang=")[1];
      // console.log(window.location.href.split("lang="));
      if (langid) {
        localStorage.setItem(this.currentUrl, langid);
        this.nowlang = langid;
        this.setLang(this.nowlang);
        // console.log(this.nowlang);
      }
      setTimeout(() => {
        this.setLang(this.nowlang);
      }, 300);
    } else {
      localStorage.setItem(this.currentUrl, "zh-CN");
    }
  },
  watch: {
    lang: function (newV) {
      console.log(newV);
      if (!this.isCN) {
        this.nowlang = localStorage.getItem(this.currentUrl);
        this.setLang(this.nowlang);
      }
    },
  },
  methods: {
    ...mapActions(["setLang"]),
    onNavClick(navIdx, nav2Idx = 0) {
      this.curNav = `${navIdx}_${nav2Idx}`;
      const url = RouteMap[this.curNav];
      if (url) {
        goto(url);
      }
    },
    gopartner() {
      goto("/partner");
    },
    onChangeLang(lang) {
      //手动选择器改变语言存入localStorage
      localStorage.setItem(this.currentUrl, lang);
      this.setLang(lang);
    },
    onLogin() {
      goto("/login");
    },
    onBrandClick() {
      goto("/");
    },
    // showPopup() {
    //   this.show = true;
    //   this.$refs.form && this.$refs.form.reset();
    // },
    // closePopUp() {
    //   this.show = false;
    // },
  },
};
</script>

<style lang='scss' scoped>
@import "~@assets/styles/vars.scss";
@import "~@assets/styles/mixin.scss";
.flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.flex-start {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.flex-end {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.nav-right ::v-deep {
  .el-input__inner {
    background-color: rgba(0, 0, 0, 0.16);
    color: #ffffff;
  }
  .el-select {
    i {
      color: #ffffff;
    }
  }
}

.pc-header {
  // box-shadow: 0px 0px 12px 0px rgba(215, 215, 215, 0.5);
  position: absolute;
  z-index: 20;
  @include flex-center("row");
  padding-left: 75px;
  padding-right: 28px;
  height: 50px;
  width: 100vw;
  color: #ffffff;
  background-color: rgba(0, 0, 0, 0.4);
  .brand-icon {
    height: 100%;
    width: 110px;
    object-fit: contain;
    margin-right: 40px;
    cursor: pointer;
    display: flex;
    align-items: center;
    position: relative;
  }
  .nav {
    flex: 1;
    @extend .flex-between;
    flex-flow: nowrap;
    .nav-item {
      height: 70px;
      display: flex;
      align-items: center;
      line-height: 24px;
      padding: 0 3px;
      margin: 0 3px;
      font-size: 14px;
      position: relative;
      cursor: pointer;
      .second-nav {
        //  display: flex;
        min-width: 120px;
        display: none;
        left: 50%;
        transform: translateX(-50%);
        bottom: -80px;
        position: absolute;
        z-index: 20;
        height: 90px;
        background-color: rgba(0, 0, 0, 0.4);
        // box-shadow: 0px 2px 12px 0px rgba(197, 196, 197, 0.12);
        // justify-content: space-around;
        // align-items: center;
        .second-nav-item {
          text-align: center;
          margin: 0 12px;
          line-height: 40px;
          position: relative;
          &.active::after {
            content: "";
            position: absolute;
            bottom: -4px;
            left: 0;
            right: 0;
            height: 1px;
            background: white;
          }
        }
      }
      &.active::after {
        content: "";
        position: absolute;
        bottom: 20px;
        left: 0;
        right: 0;
        border: 1px solid rgba(255, 255, 255, 1);
      }
      &.user-item {
        font-size: 17px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: #ffffff;
        line-height: 24px;
        i {
          font-size: 22px;
          margin-right: 3px;
        }
      }
    }
    .nav-left {
      flex-basis: 630px;
      @extend .flex-start;
      white-space: nowrap;
      .nav-item {
        padding: 0 25px;
        &:hover {
          // background: #efefef;
          .second-nav {
            display: block;
          }
        }
      }
    }
    .nav-right {
      @extend .flex-end;
      flex-basis: 280px;
      white-space: nowrap;
      .nav-item {
        margin: 0 15px;
        .boxbor {
          border: 1px white solid;
          line-height: 30px;
        }
      }
      .icon-search {
        width: 28px;
        height: 28px;
      }
    }
  }
}
</style>
